import React from 'react';
import { Text } from '../common/Text';
import { Checkbox } from '../forms';
import { View } from '../common/View';
import { tokens } from '../../tokens';
import { Setting } from './UI';
import { useSidebar } from '../sidebar/SidebarProvider';
import { useLocalPref } from "../../hooks/useLocalPref";

export function AutoCategorization() {
  const sidebar = useSidebar();
  const [autoCategorizationDisabled, setAutoCategorizationDisabled] =
    useLocalPref('autoCategorizationDisabled');

  return (
    <Setting
      primaryAction={
        <View
          style={{
            flexDirection: 'column',
            gap: '1em',
            width: '100%',
            [`@media (min-width: ${
              sidebar.floating
                ? tokens.breakpoint_small
                : tokens.breakpoint_medium
            })`]: {
              flexDirection: 'row',
            },
          }}
        >
          <Text style={{ display: 'flex' }}>
            <Checkbox
              id="settings-autoCategorizationDisabled"
              checked={!autoCategorizationDisabled}
              onChange={e =>
                setAutoCategorizationDisabled(!e.currentTarget.checked)
              }
            />
            <label htmlFor="settings-autoCategorizationDisabled">
              Enable Auto Categorization
            </label>
          </Text>
        </View>
      }
    >
      <Text>
        <strong>Auto Categorization</strong> is a feature that automatically
        assigns categories to your transactions as they sync from your bank. You
        can review and adjust them anytime.
      </Text>
    </Setting>
  );
}
